const gtmFilterSelectEvent = (typeName: string, value: any) => ({
  event: 'filter_select',
  filterType: typeName,
  selection: value,
});

export default gtmFilterSelectEvent;
